export default __webpack_public_path__ + "resources/icons/d310-1d8f.webp";